import React, { useState } from 'react';
import { FaMinus, FaPlus } from 'react-icons/fa';
import { isEditable } from '../../utils/roles';
import { InputTransparent } from '../form/input.Transparent';

export const NumLittle = props => {
  const { num, value, updateField, displayMod, canEdit = true } = props;
  const effectiveMod = typeof displayMod === 'number' ? displayMod : num.mod;

  const [editValue, setEditValue] = useState(false);
  const [editLabel, setEditLabel] = useState(false);
  const canInteract = isEditable() && canEdit;

  const sanitize = str => {
    if (typeof str === 'string' && str.trim() === '') {
      return '-';
    }
    return str;
  };

  const updateValue = value => {
    updateField(value, 'value');
    setEditValue(false);
  };

  const baseValue =
    typeof value === 'number' && typeof num?.mod === 'number'
      ? value - num.mod
      : num?.value ?? 0;

  const setMod = newValue => {
    updateField(newValue, 'mod');
  };

  const updateLabel = value => {
    updateField(sanitize(value), 'label');
    setEditLabel(false);
  };

  const updateMod = mod => {
    setMod(num.mod + mod);
  };

  const resetMod = () => setMod(0);
  const zeroOut = () => setMod(-baseValue);

  return (
    <div className='relative flex flex-wrap items-center justify-center w-full h-full'>
      <div className='flex items-center gap-1'>
        {!editLabel || !canInteract ? (
          <div
            onClick={() => canInteract && setEditLabel(true)}
            className='uppercase text-condensed text-xs text-contrast text-opacity-50'
          >
            {num.label}
          </div>
        ) : (
          <div>
            <InputTransparent
              className='h-auto px-0 py-0 m-0 text-center uppercase text-condensed text-xs text-contrast text-opacity-50'
              initValue={num.label}
              onBlur={value => updateLabel(value)}
            />
          </div>
        )}
      </div>

      {!editValue ? (
        <div className='flex items-center gap-03 parent-hover'>
          {canInteract && (
            <div
              className='cursor-pointer show-on-hover text-xs'
              onClick={() => updateMod(-1)}
              onContextMenu={e => {
                e.preventDefault();
                zeroOut();
              }}
            >
              <FaMinus size={6} />
            </div>
          )}
          <div
            onClick={() => canInteract && setEditValue(true)}
            className={`text-condensed text-xs ${
              effectiveMod > 0
                ? 'text-primary-l'
                : effectiveMod < 0
                ? 'text-secondary'
                : 'text-contrast'
            }`}
          >
            {value}
          </div>
          {canInteract && (
            <div
              className='cursor-pointer show-on-hover text-xs'
              onClick={() => updateMod(1)}
              onContextMenu={e => {
                e.preventDefault();
                resetMod();
              }}
            >
              <FaPlus size={6} />
            </div>
          )}
        </div>
      ) : (
        <div>
          {canInteract ? (
            <InputTransparent
              className='h-auto px-0 py-0 m-0 text-center text-condensed'
              initValue={num.value === 0 ? '0' : num.value}
              onBlur={value => updateValue(value)}
            />
          ) : (
            <div className='text-condensed text-xs'>
              {num.value === 0 ? '0' : num.value}
            </div>
          )}
        </div>
      )}
    </div>
  );
};
